<script>
import * as XLSX from 'xlsx';
import axios from "axios";
import {toast} from "vue3-toastify";
import modalKkMixin from "../conversation-club/modal-kk-mixin.js";

const povinne_columny = [
  'e-mail',
  'name',
  'surname',
    'company',
    'lecturer',
    'types_of_lesons',
    'group_name',
    'language_level',
    'preferred_time',
    'how_many_minutes',
    'number_of_lessons_per_month',
    'credit'
];



export default {
  name: "import-students",
  emits: ['import-successful'],
  mixins: [modalKkMixin],
  data() {
    return {
      showModalFlag: false,
      file: null,
      students: [],
      headers: [],
      isLoading: false,
      errors:[],
      organizations_options: [],
      enum_lesson_types:[      'one-to-one',      '2 students',      'group',      'minicall' ],
      preferredTimeOptions: {
        'weekday_morning': 'Weekday morning',
        'weekday_afternoon': 'Weekday afternoon',
        'weekend': 'Weekend'
      }

    };
  },
  mounted() {
    this.loadOrganizationsSelect()
    this.loadLectors()
  },
  methods: {
    // organizations-select
    loadOrganizationsSelect(){
      const url = `/organizations-select.json`
      axios.get(url).then( response => {
        this.organizations_options = response.data.options
      }).catch(error => {
        console.error('Došlo k chybě při načítání organizací:', error);
      })
    },
    async loadLectors() {
      const r2 = await axios.get('/lectors.json', {
        params: {
          ll_lector: true,
          //level: this.lesson.level
          per: 100
        }
      })
      this.lectors = r2.data.items
    },



    showModal() {
      this.showModalFlag = true;
    },
    hideModal() {
      this.showModalFlag = false;
      this.resetForm();
    },
    normalizeColumnName(name) {
      return name.toLowerCase().replace(/\s+/g, '_');
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        if (json.length > 0) {
          const originalHeaders = json[0];
          this.headers = originalHeaders.map(h => (h || '').toString().trim().replace(/\s+/g, '_').toLowerCase());

          this.errors =[]
          for (let i in povinne_columny) {
            const col = povinne_columny[i];
            if (col=='group_name' && this.headers.includes('grou_name')) {
              continue;
            }
            if (!this.headers.includes(col)) {
              this.errors .push(`Chybějící povinný sloupec: ${col}`);
            }
          }


          this.students = json.slice(1).map(row => {
            let student = {};
            this.headers.forEach((header, index) => {
              student[header] = row[index];
            });
            student['company_id'] = this.detectCompanyByOrganizationsOptions(student['company']);
            student['lecturer_id'] = this.detectLecturerByNameOrEmail(student['lecturer']);
            
            // Initialize preferred times array
            if (student['preferred_time']) {

              console.log('preferred times detact ' , student['preferred_time'] )

              const times = student['preferred_time'].toString().split(',').map(t => t.trim().toLowerCase().replace(/\s+/g, '_'));
              student['preferred_times_array'] = times;
              student['preferred_time'] = times.join(',');
            } else {
              student['preferred_times_array'] = [];
            }
            
            return student;
          }).filter(student => {
            const emailValue = student['e-mail'] || student['email'];
            return emailValue && emailValue.toString().trim() !== '';
          });
        }
      };
      reader.readAsArrayBuffer(file);
    },
    detectLecturerByNameOrEmail(lecturerName) {

      const lecturer = this.lectors.find(lector => `${lector.first_name} ${lector.last_name}` === lecturerName || lector.email === lecturerName);
      return lecturer ? lecturer.id : null;
    },


    async sendData() {
      if (this.students.length === 0) {
        alert("Nejsou žádná data k odeslání.");
        return;
      }
      this.isLoading = true;
      try {
        const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute('content');
        await axios.post('/ll/students/import',
            { students: this.students },
            { headers: { 'X-CSRF-Token': csrfToken } }
        );

        alert('Studenti byli úspěšně importováni!');
        this.$emit('import-successful');
        this.hideModal();
      } catch (error) {
        console.error('Došlo k chybě:', error);
        if (error.response) {
          const errorData = error.response.data;
          alert(`Chyba při importu: ${errorData.message || error.message}`);
        } else {
          alert('Došlo k chybě při odesílání dat.');
        }
      } finally {
        this.isLoading = false;
      }
    },
    resetForm() {
      this.students = [];
      this.headers = [];
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
    detectCompanyByOrganizationsOptions(company){
      const org = this.organizations_options.find(o => o.name === company);
      return org ? org.id : null;
    },
    isValidLessonType(value) {
      if (!value) return false;
      const normalizedValue = value.toString().trim().toLowerCase();
      return this.enum_lesson_types.indexOf(normalizedValue)>=0;
    },
    formated_header(header){
      return header.replace(/_/g, ' ');
    },
    
    toggleImportPreferredTime(student, timeKey) {
      if (!student['preferred_times_array']) {
        student['preferred_times_array'] = [];
      }
      
      const index = student['preferred_times_array'].indexOf(timeKey);
      if (index > -1) {
        student['preferred_times_array'].splice(index, 1);
      } else {
        student['preferred_times_array'].push(timeKey);
      }
      
      // Update the string value
      student['preferred_time'] = student['preferred_times_array'].join(',');
    }

  }
}
</script>

<template>
  <vue-final-modal v-model="showModalFlag" classes="modal-container" content-class="modal-content-f w90">
    <div class="modal-header">
      <h5 class="modal-title">Importovat studenty z XLSX</h5>
      <button type="button" class="close" @click="hideModal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal__content">
      <div class="mb-3">
        <label for="fileInput" class="form-label">Vyberte XLSX soubor</label>
        <input class="form-control" type="file"
               id="fileInput"
               @change="handleFileUpload"
               accept=".xlsx, .xls" ref="fileInput"
               :disabled="isLoading">
      </div>

      <div class="errors">
        <div v-for="(error, index) in errors" :key="index" class="alert alert-danger">
          {{ error }}
        </div>
      </div>


      <div v-if="students.length > 0">
        <h4>Náhled dat</h4>
        <p>Zkontrolujte prosím data před importem. Bude importováno {{ students.length }} studentů.</p>
        <div class="table-responsive" style="max-height: 40vh; overflow-y: auto;">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th v-for="header in headers" :key="header">{{ formated_header(header) }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(student, index) in students" :key="index">
              <td v-for="header in headers" :key="header"
                  :class="{ 'invalid-value': header === 'types_of_lesons' && !isValidLessonType(student[header]) }">

                <span v-if="header==`company`">
                  <select v-model="student['company_id']" class="form-control" style="max_width: 300px;">
                    <option></option>
                    <option v-for="org in organizations_options" :key="org.id" :value="org.id">{{org.id}} &nbsp;&nbsp; {{ org.name }}  </option>
                  </select>
                </span>

                <span v-else-if="header==`lecturer`">
                  <select v-model="student['lecturer_id']" class="form-control">
                    <option></option>
                    <option v-for="lector in lectors" :key="lector.id" :value="lector.id">{{lector.first_name}} {{lector.last_name}} ({{ lector.email }}) </option>
                  </select>
                </span>

                <span v-else-if="header === 'types_of_lesons'" :class="isValidLessonType(student[header] ) ? '' : `text-danger`">
                  <select v-model="student[header]" class="form-control">
                    <option></option>
                    <option v-for="type in enum_lesson_types" :key="type" :value="type">{{ type }}</option>
                  </select>
                </span>
                <span v-else-if="header === 'how_many_minutes'">
                  <select v-model="student[header]" class="form-control">
                    <option></option>
                    <option v-for="n in [30,45,60,80,90]" :key="n" :value="n">{{ n }}</option>
                  </select>
                </span>
                <span v-else-if="header==='preferred_time'">
                  <div class="preferred-time-checkboxes-import">
                    <div 
                      v-for="(label, key) in preferredTimeOptions" 
                      :key="key"
                      class="preferred-time-item-import"
                    >
                      <label class="mb-1">
                        <input 
                          type="checkbox" 
                          :checked="student['preferred_times_array'] && student['preferred_times_array'].includes(key)"
                          @change="toggleImportPreferredTime(student, key)"
                        />
                        {{ label }}
                      </label>
                    </div>
                  </div>
                </span>
                <span v-else>
                  <input type="text" v-model="student[header]" class="form-control"/>
                </span>


              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button @click="hideModal" type="button" class="btn btn-outline-dark">Zrušit</button>
      <button @click="sendData" class="btn btn-success" :disabled="isLoading || students.length === 0">
        <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{ isLoading ? 'Importuji...' : 'Odeslat data na server' }}
      </button>
    </div>
  </vue-final-modal>
</template>

<style scoped>
.invalid-value {
  background-color: #ffcccc !important;
  color: #cc0000;
  font-weight: bold;
}

.preferred-time-checkboxes-import {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 0.4rem 0.6rem;
  background-color: #f8f9fa;
  min-width: 180px;
}

.preferred-time-item-import {
  margin-bottom: 0.2rem;
}

.preferred-time-item-import:last-child {
  margin-bottom: 0;
}

.preferred-time-item-import label {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin: 0;
  font-size: 0.85rem;
}

.preferred-time-item-import input[type="checkbox"] {
  margin-right: 0.4rem;
  cursor: pointer;
}
</style>
